import { FocusEvent } from 'react';
import { FormControl, InputGroup } from "react-bootstrap";

interface Props {
  className?: string;
  onPriceChange: (price: number) => string;
  price: number;
  disabled?: boolean;
}
export default function NYPInput({
  onPriceChange,
  price,
  disabled,
  className = ''
}: Props) {

  const handlePriceChange = (e: FocusEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    if (isNaN(value) || !onPriceChange(value)) {
      e.target.value = "0";
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      ["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight"].includes(e.key)
    ) {
      return;
    }

    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
    e.currentTarget.value = e.currentTarget.value.replace(/\D/g, "");
  };

  return (
    <div className={`nyp-input d-flex ${className}`}>
      <InputGroup>
        <InputGroup.Text className='text-black border border-black'>$</InputGroup.Text>
        <FormControl
          type="text"
          maxLength={4}
          size="sm"
          className="text-center"
          defaultValue={price}
          onBlur={handlePriceChange}
          onKeyDown={handleKeyDown}
          onInput={handleInput}
          disabled={disabled}
        />
        <InputGroup.Text className='text-black border border-black'>.00</InputGroup.Text>
      </InputGroup>
    </div>
  );
}